// @flow
import React, { useEffect, useState, useMemo } from 'react';
import Spinner from '@atlaskit/spinner';
import {
    getJiraIssuesCountByJql,
    getJiraIssuesRelatedToComponentJql,
    openIssuesUrl,
} from '../../services/jira-services';

type Props = {
    virtualComponent: any,
};

const IssuesCountLink = ({ virtualComponent }: Props) => {
    const [issuesCount, setIssuesCount] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const issuesJQL = useMemo(
        () =>
            getJiraIssuesRelatedToComponentJql({
                componentName: virtualComponent.name,
                projectsIds: virtualComponent.projects?.map(({ jiraProjectId }) => jiraProjectId),
                issuePropertyKey: 'Component',
            }),
        [virtualComponent.name, virtualComponent.projects],
    );

    useEffect(() => {
        setIsLoading(true);
        getJiraIssuesCountByJql({ jql: issuesJQL })
            .then((count) => setIssuesCount(count))
            .finally(() => setIsLoading(false));
    }, [issuesJQL, virtualComponent.projects]);

    if (isLoading) return <Spinner size="small" />;

    return (
        <a
            onClick={() => openIssuesUrl(issuesJQL)}
            style={{
                WebkitLineClamp: 1,
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
            }}
        >
            {issuesCount} issue
            {issuesCount === 1 ? '' : 's'}
        </a>
    );
};

export default IssuesCountLink;
